const BaseUrl = "https://ssbusinesssetup.com:8443/ssbusiness/visa/";
const BaseUrlInvoice = "https://ssbusinesssetup.com:8443/ssbusiness/";
const BaseImgUploadUrl =
  "https://ssbusinesssetup.com:8443/ssbusiness/visa/fileupload";
const ImageUrl =
  "https://ssbusinesssetup.com:8443/filestorage/ssbusiness/images/";
export { BaseImgUploadUrl, BaseUrl, BaseUrlInvoice, ImageUrl };
